import { useState } from "react";
// material
import {
    Box,
    Step,
    Paper,
    Button,
    Stepper,
    StepLabel,
    Typography,
    StepContent,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function VerticalLinearStepper({ steps }) {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            optional={
                                index === steps.length - 1 ? (
                                    <Typography variant="caption">
                                        Last step
                                    </Typography>
                                ) : null
                            }
                        >
                            {step.label}
                        </StepLabel>
                        <StepContent>
                            <Typography>{step.description}</Typography>
                            <Box sx={{ mt: 3 }}>
                                <Button
                                    variant="contained"
                                    onClick={handleNext}
                                >
                                    {index === steps.length - 1
                                        ? "Finish"
                                        : "Continue"}
                                </Button>
                                <Button
                                    disabled={index === 0}
                                    onClick={handleBack}
                                >
                                    Back
                                </Button>
                            </Box>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>

            {activeStep === steps.length && (
                <Paper sx={{ p: 3, mt: 3, bgcolor: "grey.50012" }}>
                    <Typography paragraph>
                        Congratulations! You've successfully completed all the
                        steps. You're now ready to make a difference by
                        providing valuable feedback and ratings. Keep up the
                        great work!
                    </Typography>
                    <Button onClick={handleReset}>Reset</Button>
                </Paper>
            )}
        </>
    );
}
